import { render, staticRenderFns } from "./OnBoardingTour.vue?vue&type=template&id=20bb9f6e&"
import script from "./OnBoardingTour.vue?vue&type=script&lang=js&"
export * from "./OnBoardingTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports